<div class="container-row rules-section">
  <h4>Requests the device update its location</h4>
</div>